import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OwnerSearchComponent } from './owner-search.component';
import { TagsModule } from '../tags/tags.module';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from '../tooltip/tooltip.module';
import { SearchModule } from '../search/search.module';



@NgModule({
  declarations: [OwnerSearchComponent],
  imports: [
    CommonModule,   
    TagsModule,
    FormsModule,
    TooltipModule,
    TranslateModule,
    SearchModule
  ],
  exports: [OwnerSearchComponent]
})
export class OwnerSearchModule { }
